// src/components/ScrollToTopButton.js
import React, { useState, useEffect } from "react";
import "./index.css";
import SubscribeModal from "./landing/SubscribeModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [NewsLetterClick, setNewsLetterClick] = useState(false);
  const [show, setShow] = useState(false);

  const handleSubscribeClick = () => {
    setNewsLetterClick(true); // Triggers modal open
    setShow(true);
  };

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    setIsVisible(scrollTop > 100); // Show button after scrolling 200px
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    isVisible && (
      <>
        <div className="">
          <button className="subscribe-btn" onClick={handleSubscribeClick}>
            <FontAwesomeIcon size="lg" icon={faEnvelope} />
          </button>

          <button className="scroll-to-top" onClick={scrollToTop}>
            <FontAwesomeIcon size="lg" icon={faArrowUp} />
          </button>

          <SubscribeModal
            show={show}
            setShow={setShow}
            NewsLetterClick={NewsLetterClick}
            setNewsLetterClick={setNewsLetterClick}
          />
        </div>
      </>
    )
  );
};

export default ScrollToTopButton;
